import React, { useEffect, useRef, useState } from 'react';
import { feedback } from '@ecosystem/newron-design-system';
import { useIsMounted } from '../../tools';

type Props = {
  isActive: boolean;
  withIndicator?: boolean;
};
function Loading({ isActive, withIndicator = false }: Props) {
  const [masked, setMasked] = useState<boolean>(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(null);
  const isMounted = useIsMounted();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = null;

    if (!isActive) {
      return;
    }

    timer.current = setTimeout(() => {
      if (isMounted()) {
        setMasked(true);
      }
    }, 100);
  }, [isActive]);

  if (!isActive) {
    return null;
  }

  const { DotsLoader } = feedback;
  return (
    <div data-test-id="loading-component" className="absolute inset-0 z-10 flex items-center justify-center">
      <div className={`absolute inset-0 bg-white transition-opacity ${masked ? 'opacity-50' : 'opacity-0'}`} />
      {withIndicator && <DotsLoader testId="dots-loader" />}
    </div>
  );
}

export { Loading };
